/**
 * Created by Owner on 2016/8/9.
 */
import {Component} from '@angular/core';
import {NavController, AlertController, ViewController, NavParams} from 'ionic-angular';
import {LotteryPage} from "../lottery/lottery";
import {AppConfigService} from "../../services/appConfig.service";
import {UserService} from "../../services/user.services";
import {ReportWinLossDetailsPage} from "../reportWinLossDetails/reportWinLossDetails";

@Component({
  templateUrl: 'reportWinLoss2List.html',
  selector: 'report-win-loss2-list-page',
})
export class ReportWinLoss2ListPage {
  private recordList: any = [];
  requestData: any;
  private infiniteScrollBoolean: boolean = true;
  private dates: string;
  private totalNum: number = 0;

  constructor(private navParams: NavParams, private nav: NavController, private alertCtrl: AlertController,
              private userService: UserService, public viewCtrl: ViewController) {
    this.requestData = navParams.get("requestData");
    this.dealData(navParams.get("data"));
  }

  goDetail(item: any) {
    this.nav.push(ReportWinLossDetailsPage, {
      data: item,
      type: 2
    });
  }

  doRefresh(refresher) {
    this.getFirstData(refresher);
  }

  getFirstData(refresher: any = null) {
    this.userService.reportWinLoss2List(this.requestData, this.alertCtrl).then(data=> {
      if (!data["msg"]) {
        this.dealData(data);
      }
      if (refresher) {
        refresher.complete();
      }
    });
  }

  doInfinite(infiniteScroll) {
    infiniteScroll.enable(false);
    setTimeout(()=> {
      this.userService.reportWinLoss2ListNext(this.requestData, this.alertCtrl).then(data=> {
        if (!data["msg"]) {
          data["reslist"].map(item=> {
            item["saletz"] = (item["win"] + item["fd"] + item["bonus"] - item["tz"]).toFixed(4);
            item["fd"] = (item["fd"]).toFixed(4);
            return item;
          });
          this.recordList = this.recordList.concat(data["reslist"]);
          this.totalNum = data["totalrecord"];
          infiniteScroll.complete();
          infiniteScroll.enable(true);
        } else {
          infiniteScroll.enable(true);
          this.infiniteScrollBoolean = false;
        }
      });
    }, 500);
  }

  /**
   * 处理返回数据
   * @param data
   */
  dealData(data: any) {
    this.dates = data["dates"];
    this.totalNum = data["totalrecord"];
    this.recordList = data["reslist"];
    this.recordList.map(item=> {
      item["saletz"] = (item["win"] + item["fd"] + item["bonus"] - item["tz"]).toFixed(4);
      item["fd"] = (item["fd"]).toFixed(4);
      return item;
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/reportWinLoss2List/reportWinLoss2List.ts